import { TIER_COLOR, type Tier } from '@geosport/shared';

/** The one-liner that lands on the map while the arc draws. */
export function QuipOverlay({ text, tier }: { text: string; tier: Tier }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-[42%] z-10 flex justify-center px-6">
      <p
        className="animate-pop max-w-sm rounded-2xl bg-ink/85 px-5 py-3 text-center text-xl font-black tracking-tight shadow-2xl ring-1 ring-white/10 backdrop-blur"
        style={{ color: TIER_COLOR[tier] }}
        role="status"
        data-testid="quip"
      >
        {text}
      </p>
    </div>
  );
}
